module.exports = "/assets/ab657e612b51e8b3a7121a3ae4c6e430.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/OA.png
// module id = 1673
// module chunks = 0